// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_LinearIndex = require("../Data.LinearIndex/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Extra_Prelude = require("../Extra.Prelude/index.js");
var Mapgen = require("../Mapgen/index.js");
var Wall = (function () {
    function Wall() {

    };
    Wall.value = new Wall();
    return Wall;
})();
var Floor = (function () {
    function Floor() {

    };
    Floor.value = new Floor();
    return Floor;
})();
var Exit = (function () {
    function Exit() {

    };
    Exit.value = new Exit();
    return Exit;
})();
var DoorClosed = (function () {
    function DoorClosed() {

    };
    DoorClosed.value = new DoorClosed();
    return DoorClosed;
})();
var DoorOpen = (function () {
    function DoorOpen() {

    };
    DoorOpen.value = new DoorOpen();
    return DoorOpen;
})();
var terrainEq = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Wall && y instanceof Wall) {
            return true;
        };
        if (x instanceof Floor && y instanceof Floor) {
            return true;
        };
        if (x instanceof Exit && y instanceof Exit) {
            return true;
        };
        if (x instanceof DoorClosed && y instanceof DoorClosed) {
            return true;
        };
        if (x instanceof DoorOpen && y instanceof DoorOpen) {
            return true;
        };
        return false;
    };
});
var set = function (p) {
    return function (terrain) {
        return function (t) {
            return Extra_Prelude.unsafeFromJust(Data_LinearIndex.insertAt(p)(terrain)(t));
        };
    };
};
var placeExit = function (e) {
    return function (terrain) {
        return set(e)(Exit.value)(terrain);
    };
};
var placeDoors = function (doors) {
    return function (terrain) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (t) {
            return function (v) {
                return set(v.pos)(DoorClosed.value)(t);
            };
        })(terrain)(doors);
    };
};
var perimeter = function (r) {
    var result = {
        x: r.x - 1 | 0,
        y: r.y - 1 | 0,
        width: r.width + 2 | 0,
        height: r.height + 2 | 0
    };
    return result;
};
var insideBlock = function (v) {
    return function (b) {
        var v1 = Mapgen.unproduct(b);
        return Mapgen.inInterval(v.x)(v1.h) && Mapgen.inInterval(v.y)(v1.v);
    };
};
var flatten = Data_String_Common.replaceAll("\x0a")("");
var demoTerrain = "\x0a########################################\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#......................................#\x0a#..................................>...#\x0a#......................................#\x0a#......................................#\x0a########################################\x0a";
var charToTerrain = function (v) {
    if (v === ".") {
        return Floor.value;
    };
    if (v === ">") {
        return Exit.value;
    };
    return Wall.value;
};
var blockPositions = function (b) {
    return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(b.x)((b.width + b.x | 0) - 1 | 0))(function (x) {
        return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(b.y)((b.height + b.y | 0) - 1 | 0))(function (y) {
            return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                x: x,
                y: y
            });
        });
    });
};
var carveBlock = function (b) {
    return function (terrain) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (t) {
            return function (p) {
                return set(p)(Floor.value)(t);
            };
        })(terrain)(blockPositions(b));
    };
};
var carveRoom = carveBlock;
var carveRooms = function (rooms) {
    return function (terrain) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (t) {
            return function (b) {
                return carveRoom(b)(t);
            };
        })(terrain)(rooms);
    };
};
var arena = {
    width: 20,
    height: 20
};
var bareMap = Data_LinearIndex.fill(arena.width)(arena.height)(Wall.value);
module.exports = {
    Wall: Wall,
    Floor: Floor,
    Exit: Exit,
    DoorClosed: DoorClosed,
    DoorOpen: DoorOpen,
    arena: arena,
    bareMap: bareMap,
    charToTerrain: charToTerrain,
    flatten: flatten,
    set: set,
    blockPositions: blockPositions,
    carveBlock: carveBlock,
    carveRoom: carveRoom,
    carveRooms: carveRooms,
    perimeter: perimeter,
    insideBlock: insideBlock,
    placeDoors: placeDoors,
    placeExit: placeExit,
    demoTerrain: demoTerrain,
    terrainEq: terrainEq
};
